import React from 'react';
import store from '@apply/adminStore';
import { SectionHeader } from '../common/SharedComponents';
import { FeatureType } from '@apply/constants';
import { Navigate, Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { isFeatureEnabled } from '@apply/store/src/user/types';
import SummaryTable from './tables/SummaryTable';
import CurrentWatchlistBreakdownTable from './tables/CurrentWatchlistBreakdownTable';
import { WatchlistSummaryType } from '@apply/constants';

const WatchlistsSummary = () => {
    const { user } = store.getState();
    if (!isFeatureEnabled(user, FeatureType.Watchlists)) {
        return <Navigate to={`/adminreferral`} />;
    }

    const styles = {
        linkPaper: {
            color: '#2C5591',
            textAlign: 'center',
            padding: 30,
            fontSize: 14,
            margin: 20,
            width: 360,
            height: 740,
        },
        loginPaper: {
            color: '#2C5591',
            padding: 20,
            fontSize: 14,
            margin: 20,
        },
        flexContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            overflow: 'auto',
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    return (
        <>
            <SectionHeader title='Watchlist' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4', height: '100%' }}
            >
                <div
                    className='scrollable-content-without-search'
                    style={styles.flexContainer}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <Link
                            to={`/watchlists/vertical`}
                            style={styles.verticalPadding}
                        >
                            <h1>Vertical Watchlist</h1>
                        </Link>
                        <SummaryTable summaryTypeId={WatchlistSummaryType.Vertical} />
                        <CurrentWatchlistBreakdownTable summaryTypeId={WatchlistSummaryType.Vertical} />
                    </Paper>
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <Link
                            to={`/watchlists/rentals`}
                            style={styles.verticalPadding}
                        >
                            <h1>Rentals Watchlist</h1>
                        </Link>
                        <SummaryTable summaryTypeId={WatchlistSummaryType.Rentals} />
                        <CurrentWatchlistBreakdownTable summaryTypeId={WatchlistSummaryType.Rentals} />
                    </Paper>
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <Link
                            to={`/watchlists/sba`}
                            style={styles.verticalPadding}
                        >
                            <h1>SBA Watchlist</h1>
                        </Link>
                        <SummaryTable summaryTypeId={WatchlistSummaryType.SBA} />
                        <CurrentWatchlistBreakdownTable summaryTypeId={WatchlistSummaryType.SBA} />
                    </Paper>
                </div>
            </div>
        </>
    );
};

export default WatchlistsSummary;
